import { z } from "zod";

export const UserMinified = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  avatar: z.string().optional(),
});

export type UserMinified = z.infer<typeof UserMinified>;
